export const calculateTotalBalanceTransfer = balanceTransferList => {
  return balanceTransferList
    ? Object.values(balanceTransferList).reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0)
    : 0;
};

export const calculateMinimalCreditLimit = (totalAmount, balanceTransferCreditLimitFactor) => {
  return Math.ceil(totalAmount / balanceTransferCreditLimitFactor / 100) * 100;
};
